import { useInfiniteQuery, useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { logout } from 'services/AuthService';
import { getCompanies } from 'services/CompanyService';
import LocalStorageService from 'services/LocalStorageService';
import { selectCompany } from 'services/UserService';
import {
  LOCAL_STORAGE_ACCESS_TOKEN,
  LOCAL_STORAGE_REFRESH_TOKEN,
} from 'services/api/constants';
import { LogyxError, getToastErrorMessage } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { logout as logoutAction } from 'store/User/actions/user';
import { getNextPageParam } from 'utils/getNextPageParam';

export const useLogout = () => {
  const dispatch = useDispatch();
  return useMutation(() => logout(), {
    onError: (error: LogyxError) => {
      toast.error(getToastErrorMessage(error));
    },
    onSettled: () => {
      LocalStorageService.removeItem(LOCAL_STORAGE_ACCESS_TOKEN);
      LocalStorageService.removeItem(LOCAL_STORAGE_REFRESH_TOKEN);
      dispatch(logoutAction());
    },
    mutationKey: ReactMutationKeys.LOGOUT,
  });
};

export const useGetCompaniesInfinite = (perPage: number, searchBy: string) =>
  useInfiniteQuery({
    queryKey: [ReactQueryKeys.GET_COMPANIES_INFINITE, perPage, searchBy],
    queryFn: ({ pageParam = 1 }) => getCompanies(pageParam, perPage, searchBy),
    getNextPageParam,
    onSuccess: (data) => {
      return data;
    },
  });

export interface ISelectCompanyDTO {
  companyId?: number;
}

export const useSelectCompany = () =>
  useMutation((dto: ISelectCompanyDTO) => selectCompany(dto), {
    onError: (error: LogyxError) => {
      toast.error(getToastErrorMessage(error));
    },
    mutationKey: ReactMutationKeys.SELECT_COMPANY,
  });
